import { Navigate, useLocation } from 'react-router-dom';
import FullPageLoader from '@/components/atoms/Loader/FullPageLoader';
import useOrganizationRoles from '@/hooks/useOrganizationRoles';
import OrganizationalSettings from '@/pages/settings/OrganizationalSettings';
import Routes from '@/router/routes';
import Error404Page from '@/pages/error/Error404Page';
import useErrorStore from '@/store/ErrorStore';

function AuthOrganizationalSettings() {
  const location = useLocation();
  const { showError } = useErrorStore();

  const { isUserAdmin, isUserOwner, isLoading } = useOrganizationRoles();

  if (isLoading) return <FullPageLoader />;
  if (showError) return <Error404Page />;

  return isUserOwner || isUserAdmin ? (
    <OrganizationalSettings />
  ) : (
    <Navigate to={Routes.unauthorized.path} state={{ from: location.pathname }} replace />
  );
}

export default AuthOrganizationalSettings;
